import { Icon } from '@iconify/react';
import Ghetex from '../assets/img/portafolio/gethex-peru-nuevo.png';
import santivanez from '../assets/img/portafolio/logo_santivanez.png';
import PageBanner from '../components/layout/PageBanner';
import AnimatedSection from '../components/ui/AnimatedSection';

const casos = [
  {
    cliente: 'Gethex Perú',
    img: Ghetex,
    descripcion: 'Plataforma B2B de retail con catálogo digital, panel administrativo y control de inventario.',
    resultado: 'Automatización de atención al cliente y centralización de operaciones comerciales.',
    link: 'https://www.gethex.com.pe',
    tags: ['Retail', 'Web', 'Panel Admin'],
  },
  {
    cliente: 'Paket',
    img: null,
    descripcion: 'Sistema de gestión comercial con control de inventario, ventas y logística.',
    resultado: 'Reducción de tiempos operativos y visibilidad en tiempo real del negocio.',
    link: 'https://paket.pe',
    tags: ['ERP', 'Logística', 'Gestión'],
  },
  {
    cliente: 'Casa Santivañez',
    img: santivanez,
    descripcion: 'ERP personalizado con reportes financieros, dashboard ejecutivo y control de caja.',
    resultado: 'Información centralizada y toma de decisiones basada en datos en tiempo real.',
    link: 'https://www.infocsantivanez.net/Account/login',
    tags: ['ERP', 'Finanzas', 'Dashboard'],
  },
];

export default function Portafolio(){
    return(
        <main className="bg-[#f5f5f7] text-[#2d2d44]">
            <PageBanner
              titulo="Casos de éxito"
              crumbs={[
                { label: 'Inicio', href: '/' },
                { label: 'Portafolio' },
              ]}
            >
              <p className="text-white text-lg">Resultados reales de proyectos que transformaron negocios.</p>
            </PageBanner>
            <div className="max-w-7xl mx-auto px-4 py-12">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                  {casos.map((caso, i) => (
                    <AnimatedSection key={i} animation="fade-in-up" delay={i * 120} className="bg-white border border-black/10 rounded-2xl overflow-hidden hover:border-[#f26724]/30 hover:-translate-y-0.5 transition-all flex flex-col shadow-sm">
                      {caso.img && (
                        <div className="p-4 bg-[#dddddd]">
                          <img src={caso.img} className="w-full h-32 object-contain" alt={caso.cliente} />
                        </div>
                      )}
                      <div className="p-6 flex flex-col flex-1">
                        {!caso.img && (
                          <h3 className="text-xl font-semibold text-[#f26724] mb-4 pb-3 border-b border-black/10">{caso.cliente}</h3>
                        )}
                        {caso.img && (
                          <h3 className="text-xl font-semibold text-[#f26724] mb-3">{caso.cliente}</h3>
                        )}
                        <div className="flex flex-wrap gap-2 mb-4">
                          {caso.tags.map((tag, j) => (
                            <span key={j} className="px-3 py-1 text-xs font-medium bg-[#f26724]/10 text-[#f26724] rounded-full border border-[#f26724]/20">{tag}</span>
                          ))}
                        </div>
                        <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-1">{caso.descripcion}</p>
                        <p className="text-sm mb-4"><span className="text-green-600 font-medium">✓ Resultado:</span> <span className="text-gray-600">{caso.resultado}</span></p>
                        <a href={caso.link} className="inline-flex items-center gap-2 text-sm text-[#f26724] hover:text-[#2d2d44] transition-colors" target="_blank" rel="noopener noreferrer">
                          <Icon icon="mdi:launch" /> Ver proyecto
                        </a>
                      </div>
                    </AnimatedSection>
                  ))}
                </div>

                <AnimatedSection className="text-center mt-16 pt-8 border-t border-black/10">
                  <h2 className="text-2xl font-bold text-[#f26724] mb-3">¿Listo para el próximo caso de éxito?</h2>
                  <p className="text-gray-500 mb-6">Hablemos de tu proyecto.</p>
                  <a href="https://api.whatsapp.com/send?phone=51946564003&text=Quiero%20agendar%20una%20reuni%C3%B3n%20para%20mi%20proyecto" className="inline-flex items-center gap-2 px-8 py-4 bg-[#f26724] text-black font-semibold rounded-xl hover:bg-[#f3823c] transition-all hover:shadow-lg hover:shadow-[#f26724]/20" target="_blank" rel="noopener noreferrer">
                    Agenda una reunión <Icon icon="mdi:arrow-right" className="text-xl" />
                  </a>
                </AnimatedSection>
            </div>
        </main>)
}
